import React from 'react';

import { useState } from 'react';
import Icon from '../icon/icon';
import Abajo from '../abajo.png'
import Label from '../texts/label';
import './labelFromAcordeon.css'

  /*   return (
        <div className='labelFromAcordeon'>
            <Label value={value} /> */
            {/* <Icon value={Abajo} /> */}
   /*          <div className='iconAccordeon'></div>
        </div>
    );
} */





const LabelFromAcordeon = ({ value }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleAccordion = () => {
    setIsOpen(!isOpen);
  }

  return (
    <div className="accordion-container">
      <div className='labelFromAcordeon' onClick={handleAccordion}>
        <Label value={value} />
        <div className={`iconAccordeon ${isOpen ? 'active' : ''}`}></div>
      </div>
      <div className={`contentFromAcordeon ${isOpen ? 'open' : ''}`}>
    
      </div>
    </div>
  );
}

export default LabelFromAcordeon;
